import type { AppProps } from 'next/app';

import '@/globals.scss';
import VerifyModalMount from '@app/components/auth/VerifyModal/Mount';
import { ErrorBoundary } from '@app/components/ui/ErrorBoundary';
import { ModalProvider } from '@app/components/ui/Modal';
import { ToastProvider } from '@app/components/ui/Toast';
import { WithProviders } from '@app/components/WithProvider';
import { AuthProvider } from '@app/hooks/useAuth';
import { FirebaseProvider } from '@app/hooks/useFirebase';
import { HeadMetaProvider } from '@app/hooks/useHeadMeta';
import { WindowProvider } from '@app/hooks/useWindow';

export default function App({ Component, pageProps }: AppProps) {
  return (
    <ErrorBoundary>
      <WithProviders
        providers={[
          HeadMetaProvider,
          WindowProvider,
          ToastProvider,
          AuthProvider,
          FirebaseProvider,
        ]}
      >
        <>
          <Component {...pageProps} />
          <VerifyModalMount />
          <ModalProvider />
        </>
      </WithProviders>
    </ErrorBoundary>
  );
}
